import { Film } from "lucide-react";

const StoryboardEmptySceneState = () => (
    <div className="flex-1 flex flex-col items-center justify-center text-center p-8 text-muted-foreground animate-in fade-in duration-500">
        <div className="h-24 w-24 bg-muted/30 rounded-full flex items-center justify-center mb-6">
            <Film className="h-10 w-10 opacity-50" />
        </div>
        <h2 className="text-2xl font-semibold mb-2">Ready for Action?</h2>
        <p className="max-w-md">Select a scene from the sidebar to start creating your storyboard.</p>
    </div>
)

export default StoryboardEmptySceneState
